import React from 'react';
import { Checkbox } from '@insurancemenu/imenu-components-lib';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types';
import { PersonInfo } from 'types/electionService';
import {
  SUB_DEPENDENTS_SECTION_TEST_ID,
  SUB_INELIGIBLE_DEPENDENTS_MESSAGE_TEST_ID,
  SUB_NO_DEPENDENTS_MESSAGE_TEST_ID,
} from '../../constants';
import { DependentsWarningMessageStyled, DependentLabelStyled, DependentsWrapperStyled } from './styles';

interface Props {
  dependentsList: PersonInfo[];
  areDependentsIneligible: boolean;
  isEditable?: boolean;
  selectedDependentIds: string[];
  productLineId: ProductLineId;
  onDependentChange: (id: string) => void;
}

const DependentsSection: React.FC<Props> = ({
  areDependentsIneligible,
  dependentsList,
  isEditable,
  selectedDependentIds,
  productLineId,
  onDependentChange,
}) => {
  if (areDependentsIneligible) {
    return (
      <DependentsWarningMessageStyled data-test-id={SUB_INELIGIBLE_DEPENDENTS_MESSAGE_TEST_ID}>
        Dependents are ineligible
      </DependentsWarningMessageStyled>
    );
  }

  if (dependentsList.length === 0) {
    return (
      <DependentsWarningMessageStyled data-test-id={SUB_NO_DEPENDENTS_MESSAGE_TEST_ID}>
        No dependents
      </DependentsWarningMessageStyled>
    );
  }

  return (
    <DependentsWrapperStyled data-test-id={SUB_DEPENDENTS_SECTION_TEST_ID}>
      {dependentsList.map(({ id, firstName, lastName }) => {
        return (
          <Checkbox
            id={`${productLineId}-dependent-${id}`}
            name={`${productLineId}-dependent-${id}`}
            key={`${productLineId}-dependent-${id}`}
            label={<DependentLabelStyled>{`${firstName} ${lastName}`}</DependentLabelStyled>}
            checked={selectedDependentIds.includes(id)}
            disabled={!isEditable}
            onChange={(): void => {
              onDependentChange(id);
            }}
          />
        );
      })}
    </DependentsWrapperStyled>
  );
};

export default DependentsSection;
